import { render } from "./fileSidebar.vue?vue&type=template&id=73a72ca8"
import script from "./fileSidebar.vue?vue&type=script&lang=js"
export * from "./fileSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__